export function roundHalfToEven(n: number) {
  const floor = Math.floor(n);
  const ceil = Math.ceil(n);
  const fraction = n - floor;
  // Check if it is exactly halfway between two integers
  if (fraction === 0.5) {
    return floor % 2 === 0 ? floor : ceil;
  }
  // Regular rounding
  return Math.round(n);
}
